import { useSelector } from 'react-redux';

import { FC, useRef } from 'react';

import { selectGeoTypeFilter } from 'shared/selectors/filters/geo/selectGeoTypeFilter';
import { IconActionChevronDownSmall16 } from '@cian/ui-kit-design-tokens/icons';
import { FilterButtonV2 } from 'shared/components/FilterButtonV2';
import { GeoSuggestModalContainer } from 'shared/containers/GeoSuggestModalContainer';

import styles from './GeoSuggestV2.css';
import { useModalState } from 'shared/hooks';

export const GeoSuggestV2: FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const { label, tabItems } = useSelector(selectGeoTypeFilter);

  const { opened, onClose, onOpen } = useModalState();

  return (
    <div className={styles['container']} ref={containerRef}>
      <FilterButtonV2 afterIcon={<IconActionChevronDownSmall16 color="primary_100" />} onClick={onOpen}>
        {label}
      </FilterButtonV2>

      {opened && <GeoSuggestModalContainer onModalClose={onClose} tabItems={tabItems} />}
    </div>
  );
};
